
    // FIXME Work out the shadow issue on cards, overlapping / duplicating making it darker at the end

    // Vue, third party
    import { Component, Watch, Vue, Mixins, Prop } from "vue-property-decorator";
    import { State, Getter, Action, Mutation, namespace } from "vuex-class";

    // Sv Components
    import AddNewTask from "@/components/tasks/AddNewTask.vue";
    import EditLibraryTask from "@/components/tasks/EditLibraryTask.vue";

    // Third Party Components
    import vselect3 from "vselect3";

    // Mixin / Filters
    import ActionsMixin from "@/mixins/ActionsMixin";

    // Types
    import { ActionPlan, TaskCategory, TaskLibrary, TaskType, NewTask } from '@/store/tasks/types';
    import { VueBootstrapField } from '@/store/types';

    // Namespaces
    const Tasks = namespace("tasks");

    @Component({
        components: {
            vselect3,
            "add-new-task": AddNewTask,
            "edit-library-task":  EditLibraryTask,
        }
    })
    export default class ActionModal extends Mixins(ActionsMixin) {
        @Tasks.State(state => state.TaskTypes) taskTypes: TaskType[];

        @Tasks.Action updateTask: (payload: TaskLibrary) => Promise<void>;
        @Tasks.Action addTaskToLibrary: (newTask: NewTask) => Promise<void>;
        @Tasks.Action deleteTaskFromLibrary: (actionId: number) => Promise<void>;


        @Prop({ default: () => ([]), type: Array }) actions: TaskLibrary[];
        @Prop({ default: () => ([]), type: Array }) actionCategories: TaskCategory[];
        @Prop({ default: false, type: Boolean }) actionModal: boolean;

        @Prop({ default: null, type: Object }) currentAction: TaskLibrary;
        @Prop({ default: null, type: Object }) deleteCurrentAction: TaskLibrary;

        private editing: boolean = false;
        private currentCategory: TaskCategory = null;
        private selectedAction: TaskLibrary = null;
        private deleteActionModal: boolean = false;

        @Watch("currentAction", { deep: true })
        private setSelectedAction(action: TaskLibrary | null) {
            if (!action) return;
            this.selectedAction = this.currentAction;
            this.editing = true;
            this.setActionModalState(true);
            this.currentCategory = this.actionCategories.find(
                (category: TaskCategory) => category.taskCategoryID == this.selectedAction.taskCategoryID);
        }

        @Watch("deleteCurrentAction", { deep: true })
        private setActionToDelete(action: TaskLibrary | null) {
            this.selectedAction = action;
            this.deleteActionModal = true;
        }

        @Watch("deleteActionModal")
        private setActionDeleteModal(newVal: boolean) {
            if (!newVal) {
                this.selectedAction = null;
                this.currentCategory = null;
                this.editing = false;
            }
        }

        @Watch("actionModal")
        private setActionToClear(val: boolean) {
            if (!val) {
                this.cancelCurrentActionDeletion();
            }
            if (!this.currentAction && val) {
                this.editing = false;
            }
        }

        private setActionModalState(state: boolean) {
            this.$emit("action-modal-state", state);
        }

        private setActionDeleteModalState(action: TaskLibrary) {
            this.$emit("action-delete-modal-state", action);
        }

        /**
         * Event handler to deal with adding new tasks
         * @param newTask Task to be added
         */
		private onSaveNewTask(newTask: NewTask): void {
            newTask.taskCategoryID = this.currentCategory.taskCategoryID;
            this.addTaskToLibrary(newTask);
            this.editing = false;
        }

        /**
         * Event handler to deal with clearing up current action on close
         */
		private onCancelNewTask(): void {
            this.editing = false;
            this.currentCategory = null;
            this.selectedAction = null;
        }

        /**
         * Method to update task
         * @param updatedTask task that has been updated
         */
        private onUpdateLibraryTask(updatedTask: TaskLibrary): void {
            this.updateTask(updatedTask);
            this.selectedAction = null;
            this.setActionModalState(false);
            this.editing = false;
        }   
        
        /**
         * @summary Event handler to deal with clearing up current action on close
         */
        private onCancelEditingLibraryTask(): void {
            this.selectedAction = null;
            this.editing = false;
        }

        /**
         * @summary method to delete selected action
         * @returns void
         */
        private deleteSelectedAction(): void {
            this.deleteTaskFromLibrary(this.selectedAction.taskID);
            this.currentAction = null;
            this.deleteActionModal = false;
        }
        
        /**
         * @summary method to cancel current action to delete
         * @returns void
         */
        private cancelCurrentActionDeletion(): void {
            this.setActionModalState(false);
            this.$emit("action-state", null);
            this.deleteActionModal = false;
        }

        /**
         * @summary method to get category title
         */
        private get getCategory(): string {
            if (!this.selectedAction) return "unknown";
            const category = this.getCategoryByAction(this.selectedAction.taskID);
            return category ? category.title : "unknown";
        }
    }
